module.exports = __webpack_public_path__ + "static/media/layout-2.c43f6458.jpg";